import React from 'react';
import { Button } from '../ButtonElement';
import { BodyText, TextContainer, Box, BoxTitle, ContentText } from '../Blog/BlogElements';

const SizingGuidelines = () => {
    return (
        <BodyText>
            <TextContainer>
                <Box>
                    <BoxTitle>Sizing Guidelines</BoxTitle>
                    <ContentText>
                        <p>
                            The lack of any standardization (within brand and across brand) left us with no reliable starting point for a biometric sizing/fit standard. The variations from brand to brand based on chronological age were unable to be placed in any matrix.
                        </p>

                        <p>
                            Our objective was clearly only to improve the chances that mothers would be purchasing proper sized pacifiers to support the palate during NNS. To this end major brand pacifiers were measured with an electronic digital caliper for all chronological ages.
                        </p>

                        <p>
                            Palatal width measurements were obtained from dental impressions from varying sources and scanned with a 3 Shape R700 Orthodontic Scanner to generate STL files. In some cases IGES files provided by manufacturer were used to generate STL files of the pacifier by using Autodesk Fusion 360™ software. The STL file of each pacifier stage was then imported into Autodesk Meshmixer™ to obtain "observational fit" for contact with the tectal plate area of the palate.
                        </p>

                        <div style={{ 
                            margin: '40px 0', 
                            padding: '30px', 
                            background: '#f8f9ff', 
                            borderRadius: '12px',
                            border: '1px solid #e2e8f0',
                            textAlign: 'center'
                        }}>
                            <img 
                                src={require('../../pdfs/sizeguides2.png')} 
                                alt="Sizing Guidelines Chart" 
                                style={{ 
                                    maxWidth: '100%', 
                                    height: 'auto',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                                }}
                            />
                        </div>

                        <p>
                            Further cross reference was made with an applied "working formula". The formula was computed by plotting the 'best-fit' polynomial over points, constructed as (palate width, pacifier width), between 6 infants with ages ranging from 1 month to 24 months.
                        </p>

                        <div style={{ 
                            background: '#f7fafc', 
                            padding: '20px', 
                            margin: '20px 0', 
                            borderRadius: '8px',
                            fontFamily: 'monospace',
                            textAlign: 'center',
                            border: '1px solid #e2e8f0'
                        }}>
                            <p style={{ margin: '10px 0', color: '#2d3748', fontWeight: '600' }}>
                                <strong>Equation 1:</strong> Palate width = 0.33 * (Pacifier Width) + 22.52
                            </p>
                            <p style={{ margin: '10px 0', color: '#2d3748', fontWeight: '600' }}>
                                <strong>Equation 2:</strong> Palate width = 19.4 + 0.48 * (Pacifier Width) + 0.01 * (Pacifier Width)²
                            </p>
                        </div>

                        <p>
                            The blue line denotes the linear graph while the orange line denotes the polynomial graph. Both of these graphs have been constructed by using the pre-mentioned data points. Further, consideration was given to manufacturers' sizing of the bulb (which varied from 12.8 mm to 25 mm) and the brand's placement of chronological age recommendation in the product SKU.
                        </p>

                        <p>
                            Recently a computational simulation FEA model was developed to evaluate the dynamic contact of a pacifier with the palate (Lee et al 2021)*. This model can validate brand pacifier sizing in infant palates. This approach will allow brands to develop a biometric sizing matrix (in preparation for publication).
                        </p>

                        <p>
                            The numerous variations from one brand to another were considered and <b>"BIOMETRIC SIZING"</b> was defined by treating this available ordinal and descriptive data in groupings reflecting a pilot attempt at a sizing/fit standard. Chronological Age sizing ranges will be replaced with Biometric bulb width sizing ranges.
                        </p>

                        <div style={{ 
                            textAlign: 'center', 
                            marginTop: '40px',
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '20px',
                            flexWrap: 'wrap'
                        }}>
                            <Button 
                                as="a" 
                                href={require('../../pdfs/pacifieddescription.pdf')} 
                                target="_blank"
                                style={{
                                    background: '#38A7BA',
                                    color: 'white',
                                    padding: '12px 24px',
                                    borderRadius: '8px',
                                    textDecoration: 'none',
                                    fontWeight: '500',
                                    transition: 'all 0.3s ease',
                                    border: 'none',
                                    cursor: 'pointer'
                                }}
                            >
                                📄 View Sizing Guidelines PDF
                            </Button>
                        </div>
                    </ContentText>
                </Box>
            </TextContainer>
        </BodyText>
    )
}

export default SizingGuidelines;
